import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, Config, Platform } from '@ionic/angular';
import { ListaAdjudicacionesComponent } from '../modal/lista-adjudicaciones/lista-adjudicaciones.component';
import * as _moment from 'moment';
import { DecimalPipe, formatNumber } from '@angular/common';
import { Storage } from '@ionic/storage-angular';
import { Vibration } from '@awesome-cordova-plugins/vibration/ngx';
import { NativeAudio } from '@awesome-cordova-plugins/native-audio/ngx';
import { MqttService } from '../services/mqtt.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Autoplay, SwiperOptions } from 'swiper';
import { v4 as uuidv4 } from 'uuid';
import { Subscription } from 'rxjs';
import { User } from 'src/assets/data/interfaces/interfaces-service';
import { ApiService } from '../services/api.service';
import { UtilService } from '../services/util.service';
import { FontAwesomeService } from '../services/fontawesome.service';
import { StorageService } from '../services/storage.service';


_moment.locale('es-ES');
const moment = _moment;


@Component({
  selector: 'app-subasta',
  templateUrl: './subasta.page.html',
  styleUrls: ['./subasta.page.scss'],
})
export class SubastaPage implements OnInit, OnDestroy {
  @ViewChild('swiper') swiperRef: ElementRef;
  @ViewChild('swiperObs') swiperObsRef: ElementRef;
  compras: any = [];
  inputMessageTime = 0;
  subasta: any = {};
  adjudicaciones: any = [];
  precioFormatted;
  precio: number = 0;
  modalAdjudica;
  subastaCodigo;
  cliente;
  codigo;
  cantidad;
  canBid = false;
  textoBotonParada = "SUBASTA PARADA";
  cantidadCajas = 0;
  cantidadKilos = 0;
  cantidadKilosAdj = 0;
  cantidadCajasAdj = 0;
  totalCantidad = 0;
  totalImporte = 0;
  observaciones = [];
  tipo;
  unidad;
  tpf;
  divisible = 0;
  partida = 0;

  clockRunnig = false;
  soundFile = "assets/data/mp3/beep.mp3";
  private subscribedChanel = "";

  imagenEspecie = "assets/img/image_not_found.jpg";
  setImagenes = [];
  puertoId: any;
  puerto: any;

  paradasList = [];

  paradaPrevia = {
    precio: null,
    precio_formateado: null,
    id: null,
    tpf: null,
  };

  winner: boolean = false;
  winnerName: string = null;

  subscriptions: Subscription[] = [];

  @ViewChild('ionicInput', { static: false }) ionicInput;
  fechaCabecera;

  user: User = {
    username: null,
    userId: null,
    clientes: null,
    roles: null,
  };

  codigoGrupo: any;

  permitirBajadaPrecio: boolean = true; // control de modificacion del precio

  allowMediaCss: boolean = true; // Mediante esta variable y la altura del dispositivo se controla si se activan unas clases que reformatean la pagina

  constructor(
    // public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public router: Router,
    public activateRoute: ActivatedRoute,
    public config: Config,
    private sanitizer: DomSanitizer,
    public decimalPipe: DecimalPipe,
    public storage: Storage,
    public mqttService: MqttService,
    public platform: Platform,
    public vibration: Vibration,
    public nativeAudio: NativeAudio,
    public apiService: ApiService,
    public utilService: UtilService,
    public faService: FontAwesomeService,
    public storageService: StorageService,
  ) { }

  configSwipe: SwiperOptions = {
    modules: [Autoplay],
    speed: 2000,
    autoplay: {
      delay: 1500,
      disableOnInteraction: false,
    },
    loop: true,
    allowTouchMove: false,
    loopPreventsSliding: true,
    preventInteractionOnTransition: true,
  }


  public cleanUrls(fao) {
    this.setImagenes.forEach(element => {
      if (element.foto) {
        element.foto = element.foto.trim();
        this.sanitizer.bypassSecurityTrustUrl(element.foto);
      }
      else{
        element.foto = this.storageService.urlSpecies + "e_" + fao?.toLowerCase() + ".JPG";
      }
    });

  }

  ionViewWillEnter() {
    this.platform.ready().then(() => this.allowMediaCss = this.platform.height() > 640 ? false : true);
  }

  ionViewWillLeave(): void {
    this.mqttService.publicar(
      'alive/' + this.user.userId,
      '{"event":"dc","clien":"' + this.user.userId + '","codS":"' + this.subasta.codigo + '","nombre":"' + this.user.username + '"} '
    )
    this.mqttService.desuscribir(this.subscribedChanel);
  }

  ionViewDidLeave() {
    this.subscriptions?.forEach((sub) => { sub.unsubscribe(); });
  }

  public doSwiperAutoPlay() {
    this.swiperRef.nativeElement.swiper.autoplay.start();
  }

  ngOnDestroy(): void { }

  ngAfterViewInit() {
    // TimeOut necesario para la correcta inicializacion de variables
    setTimeout(() => {
    let swiper1Instance = this.swiperRef.nativeElement.swiper;
    let swiper2Instance = this.swiperObsRef.nativeElement.swiper;

    swiper1Instance.on('slideChange', () => {
      swiper2Instance.slideTo(swiper1Instance.activeIndex);
  });

  swiper2Instance.on('slideChange', () => {
      swiper1Instance.slideTo(swiper2Instance.activeIndex);
  });
}, 0);

    // const swiper1 = this.swiperRef.nativeElement.swiper;
    // const swiper2 = this.swiperObsRef.nativeElement.swiper;



    // Sincronizar
    // swiper1.controller.control = swiper2;
    // swiper2.controller.control = swiper1;
  }
  ngOnInit() {
    this.storage.get("user").then(data => {
      this.user.username = data.username;
      this.user.userId = data.userId;
      this.user.clientes = data.clientes;
      this.user.roles = data.roles;
      this.activateRoute.queryParams.subscribe(data => {
        this.subscribedChanel = "subasta/" + data.code;
        this.subasta.codigo = data.code;
        this.mqttService.suscripcion(this.subscribedChanel);
        this.mqttService.publicar(
          'alive/' + this.user.userId,
          '{"event":"conn","clien":"' + this.user.userId + '","nombre":"' + this.user.username + '","codS":"' + this.subasta.codigo + '"}'
        );
        this.apiService.getAdjudicaciones(this.user.userId).subscribe((data: any) => {
          this.compras = data.adjudicaciones;
          this.totalCantidad = this.getTotalesCantidad();
          this.totalImporte = this.getTotalesImporte();
          if (data.partida) {
            this.cantidadCajas = data.partida.cantidad_partida_unidad_restante;
            this.cantidadKilos = data.partida.cantidad_partida_kilos_restante;
          }
          if (this.clockRunnig) {
            this.canBid = true;
            this.textoBotonParada = "PARAR";
          }
        });
      });
      this.mqttSwitch();
    });
  }

  /**
   * Función para controlar la información de los mensajes de la subasta.
   */
  mqttSwitch() {
    this.mqttService.mensaje.next(""); //Limpieza de mensaje mqtt para evitar reapertura de modal selector al volver al componente
    this.subscriptions.push(this.mqttService.mensaje.subscribe(data => {
      switch (data['event']) {
        case 'alert':
          this.setButtonStopSubasta();
          this.vibracionSonido();
          this.textoBotonParada = "Comenzamos";
          this.winner = false;
          this.winnerName = null;
          break;
        case 'alerta':
          this.textoBotonParada = data['num'];
          this.permitirBajadaPrecio = true;
          this.winner = false;
          break;
        case 'enable':
          this.permitirBajadaPrecio = true;
          // this.getParadaList(this.partida);
          if (this.winner) { return; } // Si el subastador permite nuevas paradas y usuario ha ganado ya
          this.canBid = true;
          this.textoBotonParada = "PARAR";
          // if (!data["sub"]) { this.inputMessageTime = Date.now(); } // Si el subastador permite nuevas paradas
          this.inputMessageTime = Date.now();
          this.winner = false;
          break;
        case 'change':
          this.subasta.proveedor = data['pro'];
          this.subastaCodigo = data['codS'];
          this.codigo = data['part'];
          this.tpf = data['tpf'];
          this.unidad = data['unid'];
          this.tipo = data['tipo'];
          // this.observaciones=data['observaciones'];
          this.cantidadCajas = data['caj'];
          this.cantidadKilos = data['kgs'];
          this.cantidad = (this.unidad == 'CA') ? this.cantidadCajas : this.cantidadKilos;
          this.subasta.especie = data['esp'];
          this.precio = (data['precio']) ? data['precio'] : 0;
          this.precioFormatted = this.decimalPipe.transform(this.precio, "1.2-2", "es");
          this.divisible = data['div'];
          this.codigoGrupo = data["grupo"];
          if (data["part"] != this.partida) {
            this.getParadaList(data["part"]);
          }
          this.permitirBajadaPrecio = true;
          this.partida = data['part'];
          this.puertoId = data['puertoId'];
          this.puerto = data['puerto'];
          this.setImagenes = [];
          if (data["lista"]?.length > 0) {
            this.apiService.getFoto(data['lista']).subscribe(dataP => {
              if (dataP?.length == 0) { // Si no hay imagenes recibidas entonces se muestra la imagen de la especie, guardada en assets/img/ nombre_especie .jpg
                this.imagenEspecie = this.storageService.urlSpecies + "e_" + data['fao']?.toLowerCase() + ".JPG";
              } else {
                this.imagenEspecie = null;
                this.setImagenes = dataP;
              //   setTimeout(() => {
              //     console.log('Actualizando Swipers...');
              //     this.swiper1Instance.update();
              //     this.swiper2Instance.update();
              //     console.log('Swipers actualizados.');
              // });
                this.cleanUrls(data['fao']);
              }
              this.doSwiperAutoPlay();
            }, error => {
              this.imagenEspecie = this.storageService.urlSpecies + "e_" + data['fao']?.toLowerCase() + ".JPG";
            })
          } else {
            this.imagenEspecie = null;
          }
          this.utilService.mostrarToast('Datos Actualizados.', 2000, "bottom");
          this.vibracionSonido();

          console.log('this.observaciones :>> ', this.observaciones);
          break;
        case 'fin':
          this.utilService.mostrarToast('Subastada Parada.', 2000, "bottom");
          if (data["aceptarParadas"] == 0) { // Si la configuración de la subasta no permite pujar fuera de tiempo
            this.setButtonStopSubasta();
            this.permitirBajadaPrecio = false;
          }
          this.getParadaList(this.partida);
          this.vibracionSonido();
          this.clockRunnig = false;
          break;
        case 'end':
          this.utilService.mostrarToast('Subasta Finalizada.', 2000, "bottom");
          this.vibracionSonido();
          this.clearSubastaData();
          this.clockRunnig = false;
          this.setButtonStopSubasta();
          this.winner = false;
          break;
        case 'cp':
          if (this.permitirBajadaPrecio || data["corregir"] == true) {
            if (this.precio != data['precio']) { this.inputMessageTime = Date.now(); }
            this.precio = data["precio"];
          }
          if (this.permitirBajadaPrecio) { this.canBid = true; this.textoBotonParada = "PARAR"; }
          this.precioFormatted = this.decimalPipe.transform(this.precio, "1.2-2", "es");
          this.clockRunnig = true;
          break;
        case 'pf':
          this.utilService.mostrarToast('Partida Finalizada.', 2000, "bottom");
          this.vibracionSonido();
          this.winner = false;
        case 'ok':
          if (data['clien'] == this.user.userId) {
            this.apiService.getAdjudicaciones(this.user.userId).subscribe((data: any) => {
              this.compras = data.adjudicaciones;
              this.totalCantidad = this.getTotalesCantidad();
              this.totalImporte = this.getTotalesImporte();
              if (data.partida) {
                this.cantidadCajas = data.partida.cantidad_partida_unidad_restante;
                this.cantidadKilos = data.partida.cantidad_partida_kilos_restante;
              }
            });
            this.utilService.mostrarToast('Compra Aceptada.', 2000, "bottom");
            this.vibracionSonido();
          }
          this.winner = false;
          break;
        case 'ba':
          this.apiService.getAdjudicaciones(this.user.userId).subscribe((data: any) => {
            this.compras = data.adjudicaciones;
            this.totalCantidad = this.getTotalesCantidad();
            this.totalImporte = this.getTotalesImporte();
            if (data.partida) {
              this.cantidadCajas = data.partida.cantidad_partida_unidad_restante;
              this.cantidadKilos = data.partida.cantidad_partida_kilos_restante;
            }
          });
          this.winner = false;
          break;
        case "winner":
          if (data["clien"] == this.user.userId) { this.winner = true; this.vibracionSonido(); }
          if (data["mostrar"] == 1) { this.winnerName = data["nombre"] }
          break;
        case "delWinner":
          if (this.winner == true) {
            this.utilService.mostrarToast("Se ha cancelado la puja.", 1000, "bottom");
            this.winner = false;
          }
          this.setButtonStopSubasta();
          break;
        case "pr":
          this.setButtonStopSubasta();
          break;
        case "reload":
          this.getParadaList(this.partida);
          if (data["alert"]) {
            this.utilService.mostrarToast('Datos Actualizados.', 1000, "bottom");
          }
          break;
      }

    }))
  }

  /**
   * Modifica el texto del botón e impide seguir pujando
   */
  setButtonStopSubasta() {
    this.canBid = false;
    this.textoBotonParada = "SUBASTA PARADA";
  }

  sendMSG() {
    if (this.canBid) {
      this.vibracionSonido();
      let msg = '{"event":"off", "msjIn":' + this.inputMessageTime + ', "msjOut":' + Date.now() + ', "precio":' + this.precio
        + ' , "clien":"' + this.user.userId + '" , "user":"' + this.user.username + '" , "codS":"' + this.subastaCodigo + '", "part":"' + this.codigo + '"}';
      this.send(msg);
      this.permitirBajadaPrecio = false;
    }
  }

  send(msg) {
    this.mqttService.publicar(this.subscribedChanel, msg);
    this.setButtonStopSubasta();
  }

  async sacaAdjudica() {
    const subasta = this.subasta.codigo;
    const cliente = this.user.userId;
    const nvParam = { cliente, subasta };
    this.modalAdjudica = await this.modalCtrl.create({ component: ListaAdjudicacionesComponent, componentProps: nvParam });
    return await this.modalAdjudica.present();
  }

  getTotalesCantidad() {
    if (this.compras != null && this.compras != undefined) {
      return this.compras.map(t => Number.parseFloat(t.cantidadkm.toFixed(2))).reduce((acc, value) => (acc + value), 0);
    }
    return 0;
  }

  getTotalesImporte() {
    if (this.compras != null && this.compras != undefined) {
      return this.compras.map(t => Number.parseFloat(t.importe.toFixed(2))).reduce((acc, value) => (acc + value), 0);
    }
    return 0;
  }

  /*************************/
  /*** PARADAS PREVIAS ****/
  /***********************/

  getParadaList(idPartida) {
    this.apiService.getParadasPrevias(this.user.userId, idPartida).subscribe(result => {
      if (result.length > 0) {
        this.paradaPrevia = result[0];
      } else {
        this.clearParadaPrevia();
      }
    }), error => {
      console.log("error de recepción de datos de paradas", error);
    };
  }

  createParadaPrevia() {
    if (!this.mqttService.client || !this.mqttService.client?.connected || this.mqttService.client?.reconnecting) {
      this.utilService.showAlert(2, "Fallo de conexión", "Aceptar").then(result => {
      });
      return;
    }
    setTimeout(() => {
      if (this.paradaPrevia.precio <= 0) {
        this.utilService.showAlert(1, "Precio no válido", "Aceptar").then(result => {
          try { setTimeout(() => { this.ionicInput.setFocus(); }, 50); }
          catch (error) { }
        });
        return;
      }
      let uid = uuidv4();
      this.paradaPrevia.id = uid;
      this.paradaPrevia.tpf = this.tpf;
      this.mqttService.publicar(
        'alive/' + this.user.userId,
        '{"event":"parada","codS":' + this.subastaCodigo +
        ',"usuario":' + this.user.userId +
        ',"precio":' + this.paradaPrevia.precio +
        ',"grupo":"' + this.codigoGrupo +
        '","id":"' + uid + '" } '
      );
    }, 100);
    this.showParadaPrevia = false;
  }

  deleteParadaPrevia() {
    this.mqttService.publicar(
      'alive/' + this.user.userId,
      '{"event":"delParada","codS":' + this.subastaCodigo + ',"usuario":' + this.user.userId + ',"id":"' + this.paradaPrevia.id + '"}'
    );
  }

  clearParadaPrevia() {
    this.paradaPrevia = {
      precio: 0,
      precio_formateado: "0,00",
      id: null,
      tpf: null,
    };
  }

  /*************************************/
  /******* TOGGLE SHOW PARADA *********/
  /***********************************/
  showParadaPrevia: boolean = false;

  pressDownToggle($event?) {
    if ($event && $event.cancelable) { $event.preventDefault(); }
    this.showParadaPrevia = true;
  }

  pressUpToggle($event?) {
    if ($event && $event.cancelable) { $event.preventDefault(); }
    this.showParadaPrevia = false;
  }

  blurEye() {
    if (this.showParadaPrevia == true) { this.showParadaPrevia = false; }
  }

  /******************************************/
  /*********** CONTROL DE INPUTS ***********/
  /****************************************/

  /**
   * Limpieza de input al entrar en el foco.
   * @param $event
   * @param partida
   */
  updateFocus($event?, pedido?) {
    this.showParadaPrevia = true;
    this.paradaPrevia.precio = "";
    this.paradaPrevia.precio_formateado = "";
    $event.target.value = "";
  }

  /**
   * Control de salida de foco de input, si no se ha introducido ningún valor se reinicia la cantidad seleccionada a la original de la linea
   * @param $event
   * @param partida
   */
  updateBlur($event?) {
    this.showParadaPrevia = false;
    if ($event.target.value == '') {
      $event.target.value = 0;
    }
    if ($event.target.value.toString().includes('.') && $event.target.value.toString().includes(',')) {
      $event.target.value = $event.target.value.replace('.', "");
      $event.target.value = $event.target.value.replace(',', ".");
    }
    if ($event.target.value.toString().includes(',')) {
      $event.target.value = $event.target.value.replace(',', ".");
    }
    this.paradaPrevia.precio = +$event.target.value;
    this.paradaPrevia.precio_formateado = formatNumber(+$event.target.value, "es-Es", "1.2-2");
  }

  onChange($event) {
    if ($event.target.value.toString().length == 1 && $event.target.value.toString().includes('.')) {
      $event.target.value = '0.';
    }
    if ($event.target.value.toString().length == 1 && $event.target.value.toString().includes(',')) {
      $event.target.value = '0,';
    }
    if ($event.target.value.toString().includes(',') && $event.target.value.toString().includes('.')) {
      if ($event.target.value.toString().substr()[$event.target.value.toString().length - 1] == ',' || $event.target.value.toString().substr()[$event.target.value.toString().length - 1] == '.') {
        $event.target.value = $event.target.value.slice(0, -1);
      }
    }
    if ($event.target.value.toString().includes(' ')) {
      $event.target.value = $event.target.value.replace(/\s/g, "");
    }
    if ($event.target.value.toString().includes('-')) {
      $event.target.value = $event.target.value.replace('-', "");
    }
    if ($event.target.value.toString().includes(',')) {
      if ($event.target.value.toString().split(',').length > 2) {
        $event.target.value = $event.target.value.toString().replace(/,\s*$/, "");
      }
    }
    if ($event.target.value.toString().includes('.')) {
      if ($event.target.value.toString().split('.').length > 2) {
        $event.target.value = $event.target.value.toString().replace(/.\s*$/, "");
      }
    }
  }

  numberOnlyValidation($event: any) {
    const pattern = /[0-9.,]/;
    let inputChar = $event.key;
    if (inputChar == 'Unidentified' || inputChar == 'Backspace') {
      return
    }
    // Evita el nuevo caracter si no es un numero
    if (!pattern.test(inputChar)) {
      $event.preventDefault();
      return
    }

    // Evita mas de dos decimales
    if (($event.target.value + $event.key).toString().includes('.')) {
      if (($event.target.value + $event.key).toString().split(".")[1].length > 2) {
        $event.preventDefault();
      }
    }
    if (($event.target.value + $event.key).toString().includes(',')) {
      if (($event.target.value + $event.key).toString().split(",")[1].length > 2) {
        $event.preventDefault();
      }
    }
    try { if (parseFloat(($event.target.value + $event.key).toString()) > 9999.99) { $event.preventDefault(); } }
    catch (error) { console.log("Error de control de input. ", error); }
  }

  /**
   * Funcion para generar vibracion y sonido en app.
   */
  vibracionSonido() {

    try {
      this.vibration.vibrate(1000);
      this.nativeAudio.preloadSimple('sonido1', this.soundFile).then(
        (data) => { this.nativeAudio.play('sonido1').then((data) => { }), (error) => { } },
        (err) => { console.log(err) }
      );
    } catch (error) { console.log("Control de error de vibracion o sonido"); }
  }

  /**
   * Limpieza de campos de panel de subasta. La limpieza provocará el bloqueo de parada previa
   */
  clearSubastaData() {
    this.subasta.proveedor = null;
    this.subasta.especie = null;
    this.puertoId = null;
    this.puerto = null;
    this.observaciones = [];
    this.cantidad = null;
    this.precioFormatted = null;
    this.setImagenes = [];
    this.imagenEspecie = null;
    this.doSwiperAutoPlay();
  }

}
